import React, { useContext, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Library from './Library';
import Packages from './Packages';
import { AppContext } from 'views/App/context';
import { DTBS_NAV_ITEMS } from './navItems';
import Assignments from './Assignments';
import Distribution from './Distribution';

export default function DTBRoutes() {
  const { setCurrentModule, registerNavItems } = useContext(AppContext);

  useEffect(() => {
    setCurrentModule('dtbs');
    registerNavItems('dtbs', DTBS_NAV_ITEMS);
  }, [setCurrentModule, registerNavItems]);

  const getDefaultRoute = () => {
    return (
      <Navigate
        to='./dtb'
        replace
      />
    );
  };

  return (
    <Routes>
      <Route
        path=''
        element={getDefaultRoute()}
      />
      <Route
        path='library/*'
        element={<Library />}
      />
      <Route
        path='packages/*'
        element={<Packages />}
      />
      <Route
        path='assignments/*'
        element={<Assignments />}
      />
      <Route
        path='distribution/*'
        element={<Distribution />}
      />
      */
      <Route
        path='*'
        element={
          <Navigate
            to='./library'
            replace
          />
        }
      />
    </Routes>
  );
}
